module.exports = __webpack_public_path__ + "img/banner.63fd9154.jpg";